import { subscriptionPlan } from './reducers';
export default subscriptionPlan;
